import { Component, computed, effect } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomComponent } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/custom/custom.component';
import { IKpiCard } from '@cta-analytics-details/cta-analytics-details-kpis-tile/cta-analytics-details-kpi-card/cta-analytics-details-kpi-card.interface';
import { DeliverableFindingsStore } from '@cta-analytics-dialog/deliverable-analytics-content/deliverable-findings.store';
import { EDeliverableType } from '@enums/campaign.enum';
import { ICustomAnalytics } from '@interfaces/deliverable-analytics.interface';
import { TranslateModule } from '@ngx-translate/core';
import { StreamDetailsDeliverableBaseDirective } from '../../stream-details-deliverable-base.directive';
import { ICustomStreamAnalyticsTableData } from './custom-stream-analytics.interface';

@Component({
  imports: [TranslateModule, MatTableModule, MatSortModule, MatButtonModule, CustomComponent],
  providers: [DeliverableFindingsStore],
  selector: 'app-custom-stream-analytics',
  templateUrl: './custom-stream-analytics.component.html',
})
export class CustomStreamAnalyticsComponent extends StreamDetailsDeliverableBaseDirective<
  ICustomStreamAnalyticsTableData,
  ICustomAnalytics
> {
  public override readonly deliverableType = EDeliverableType.custom;
  public override readonly kpiCardData: IKpiCard | null = null;
  public override readonly displayedColumns: string[] = ['timestamp', 'status', 'actions'];
  public override readonly dataSource: MatTableDataSource<ICustomStreamAnalyticsTableData> = new MatTableDataSource();
  public override readonly currentDeliverable = computed(() => {
    const deliverableId = this.deliverableId();
    const executionAnalytics = this.executionAnalyticsWithFindings();

    if (deliverableId && executionAnalytics) {
      return executionAnalytics?.ctaAnalytics?.customs?.find((c) => c.deliverableId === deliverableId);
    }

    return null;
  });

  constructor() {
    super();

    effect(() => {
      if (this.executionAnalyticsWithFindings()) {
        this.setStatus();
        this.setStreamData();
      }
    });

    effect(() => {
      if (this.executionAnalyticsWithFindings() && this.timelineData()) {
        this.prepareChartAndTableData();
      }
    });
  }

  protected override setCounts(): void {
    return;
  }

  protected override setKeywordList(): void {
    return;
  }

  protected override prepareChartAndTableData(): void {
    return;
  }
}
